import { useTheme } from "@mui/material/styles";
import { Box, Card, CardContent, Typography, List, ListItem, Divider, useMediaQuery } from "@mui/material";
import { CheckCircle } from "lucide-react";

const MOVING_TIPS = [
  
  {
    title: "Start packing non-essential items early",
    description: "Begin with items you don't use regularly, like seasonal decorations, books, and out-of-season clothing."
  },
  {
    title: "Notify important parties of your address change",
    description: "Remember to update your address with banks, subscription services, and government agencies."
  },
  {
    title: "Transfer or set up utilities",
    description: "Arrange for utilities to be disconnected at your old home and connected at your new one."
  }
];

export default function MovingTips() {
  const theme = useTheme(); 
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, paddingTop: '20px' }}>
      <Box sx={{ width:isMobile ? "100%" : "70%" }}>
        <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 4 }}>
              Moving Tips & Checklist
            </Typography>
            <List sx={{ padding: 0 }}>
              {MOVING_TIPS.map((tip, index) => (
                <ListItem key={index} sx={{ display: "flex", alignItems: "flex-start", paddingLeft: 0 }}>
                  <CheckCircle style={{ color: theme.palette.primary.main, marginRight: "8px" }} />
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: "medium", color: "text.primary" }}>
                      {tip.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                      {tip.description}
                    </Typography>
                  </Box>
                </ListItem>
              ))}
            </List>
            <Divider sx={{ my: 3 }} />
            <Typography variant="body2">
              <a href="#" style={{ color: theme.palette.primary.main, textDecoration: "none" }}>
                View full moving checklist →
              </a>
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}